// eslint-disable-next-line func-names
export default function () {
  const el = document.querySelector('main [tabindex]');
  if (el) el.focus();
}
